import classes from "./Login.module.css";
import {Button, TextField, InputAdornment, IconButton, CircularProgress, Typography} from "@mui/material";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import logo from "../../store/logo.png"
import React, { useState } from 'react';
import axios from 'axios';
import {path} from "../../routes"

const Login = (props) =>{
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [auth, setAuth] = useState();


    const handleRegister = async () => {
        try {
          await axios.post(`${path}/register`, { username, password });
          alert('Registration successful');
        } catch (error) {
          console.error(error);
          alert('Registration failed');
        }
      };

    const handleLogin = async () => {
        if (!username.trim() || !password.trim()) {
            setError('Please enter username and password');
            return;
        }
        setError('');
        setLoading(true);
        try {
            const url = `${path}/login`;
            console.log('🔐 Login endpoint:', url);
            const response = await axios.post(url, {
                username: username.trim(),
                password
            });
            const data = response.data;
            if (!data || !data[0]) {
                setError('Invalid response from server');
                return;
            }
            const user = data[0];
            const userData = {
                username: user.username,
                userType: user.userType,
                id: user.id,
                cOrganization_id: user.cOrganization_id,
                logoPath: user.logoPath,
                Organizace: user.Organizace,
                modul_slideshow: user.modul_slideshow,
                modul_week_slideshow: user.modul_week_slideshow,
                modul_calendar_navigation: user.modul_calendar_navigation,
                modul_vienna_slide: user.modul_vienna_slide,
                modul_diplomat: user.modul_diplomat,
                allowKioskSettings: user.allowKioskSettings === true || user.allowKioskSettings === 1
            };
            localStorage.setItem('userData', JSON.stringify(userData));
            props.dataFill(
                user.username,
                user.userType,
                user.id,
                user.cOrganization_id,
                user.logoPath,
                user.Organizace,
                user.modul_slideshow,
                user.modul_week_slideshow,
                user.modul_calendar_navigation,
                user.modul_vienna_slide,
                user.modul_diplomat,
                user.allowKioskSettings !== undefined ? user.allowKioskSettings : true
            );
        } catch (err) {
            console.error(err?.response || err);
            let errorMessage = 'Login failed. Please try again.';
            const data = err?.response?.data;
            if (data !== undefined && data !== null) {
                errorMessage = typeof data === 'string' ? data : (data.message || data.error || errorMessage);
            } else if (err?.message) {
                errorMessage = err.message;
            }
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={classes.flex}>
            <div className={classes.container}>
                <div className={classes.logo}>
                    <img src={logo} alt="Logo"/>
                </div>
                <div className={classes.inputs}>
                    <TextField
                        onChange={(e) => { setUsername(e.target.value); setError(''); }}
                        id="standard-basic"
                        fullWidth
                        label="Username"
                        variant="standard"
                        disabled={loading}
                        sx={{ width: '100%' }}
                    />
                    <TextField
                        onChange={(e) => { setPassword(e.target.value); setError(''); }}
                        id="password-field"
                        fullWidth
                        label="Password"
                        variant="standard"
                        type={showPassword ? "text" : "password"}
                        disabled={loading}
                        sx={{ width: '100%' }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() => setShowPassword(!showPassword)}
                                        edge="end"
                                        size="small"
                                        disabled={loading}
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </div>
                {error && (
                    <Typography variant="body2" color="error" sx={{ width: '100%', textAlign: 'center', mt: 0.5 }}>
                        {error}
                    </Typography>
                )}
                <Button
                    color="primary"
                    onClick={handleLogin}
                    disabled={loading}
                    sx={{
                        minWidth: 140,
                        width: { xs: '100%', sm: 'auto' },
                        mt: 1
                    }}
                    variant="contained"
                    size="large"
                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                >
                    {loading ? 'Logging in…' : 'Log In'}
                </Button>
            </div>
        </div>
    );
}

export default Login